export const CALENDAR_WINDOW_CONSTANTS = {
    ANALYTICS_WINDOW_TYPES: {
        MOVING_WINDOW: 1,
        CALENDAR_WINDOW: 2,
        DASHBOARD_WINDOW: 3,
    },
};
